import { track } from "@amplitude/analytics-react-native";
import { View } from "react-native";
import { FULL_PREVIEW_PHOTO_DETAIL } from "src/api/featureFlags";
import PhotoVariant from "src/api/graphql/__generated__/enums/PhotoVariant";
import { FullPublicPhotoFragmentFragment } from "src/api/graphql/__generated__/graphql";
import { StickerRowItem } from "src/components/StickerRow";
import { ParsedStickerRowItem } from "src/components/StickerRow/types";
import Touchable from "src/components/Touchable";
import VideoDurationDisplay from "src/components/VideoDurationDisplay";
import parseGatheringPreviewTemplateUrl from "src/helpers/parseV0TemplateUrl/parseGatheringPreviewTemplateUrl";
import usePalette from "src/hooks/usePalette";
import { useModal } from "src/modals";
import PublicGatheringModal from "src/modals/configs/PublicGatheringModal";
import { radiusSmall } from "src/styles/radius";
import { Image } from "src/swsh-native";
import { useGatheringPublicFullStore } from "../../../../hooks/useGatheringPublicFullStore";

const borderRadius = radiusSmall;
const GatheringPublicFullPhoto = ({
	photo,
	sticker,
	width,
	height,
}: {
	photo: FullPublicPhotoFragmentFragment;
	sticker: ParsedStickerRowItem | null;
	width: number;
	height: number;
}) => {
	const { primary } = usePalette();
	const src = parseGatheringPreviewTemplateUrl({
		readUrl: photo.readUrl,
	});
	const gatheringId = useGatheringPublicFullStore((state) => state.gatheringId);
	const setPopUpVariant = useGatheringPublicFullStore((state) => state.setPopUpVariant);
	const { presentModal } = useModal<PublicGatheringModal>();

	return (
		<View
			style={{
				width,
				height,
			}}
		>
			<Touchable
				animation="None"
				containerStyle={{
					backgroundColor: `${primary}50`,
					width,
					height,
					borderRadius,
				}}
				onPress={() => {
					track("gathering_publicFull_photoPress", {
						gatheringId,
						photoId: photo.photoId,
					});
					if (FULL_PREVIEW_PHOTO_DETAIL) {
						presentModal("PhotoPublicPreviewModal", {
							props: {
								gatheringId,
								photo,
							},
						});
					} else {
						setPopUpVariant(
							photo.variant === PhotoVariant.Video ? "VideoDetail" : "PhotoDetail",
						);
					}
				}}
			>
				{src && (
					<Image
						alt="Album photo"
						src={src}
						dim={{
							width,
							height,
						}}
						style={{
							borderRadius,
						}}
					/>
				)}
				{photo.variant === PhotoVariant.Video && photo.videoDuration != null && (
					<VideoDurationDisplay
						duration={photo.videoDuration}
						style={[
							{
								top: 0,
								right: 0,
								position: "absolute",
								borderTopRightRadius: borderRadius,
							},
						]}
					/>
				)}
			</Touchable>
			<StickerRowItem sticker={sticker} />
		</View>
	);
};
export default GatheringPublicFullPhoto;
